import styled from "styled-components";

const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1rem;
  gap: 20px;
`;

const TabHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: flex-start;
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const TabsHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 1px 0px;
  border-bottom: ${(props) => (props.showBorder ? '1px solid' : 'none')};
  border-bottom-color: ${(props) => props.theme.colors.silverGrayTwo};
  width: ${(props) => props.width || '100%'};
  gap: 10px;
  max-height: 70px;
  justify-content: space-between;
`;

const IconHeader = styled.div`
  border-radius: 12px;
  padding: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap:16px;

  & > .MuiFormControlLabel-root {
    margin-right: 0px;
  }
`;

const Tab = styled.div`
  padding: 9px 0px;
  cursor: pointer;
  border-bottom: 2px solid ${(props) => (props.isActive ? props.theme.colors.activeBlue : 'transparent')};
  color: ${(props) => (props.isActive ? props.theme.colors.activeBlue : props.theme.colors.greyEleven)};
  ${(props) => props.theme.fonts.variant.regular()};
  font-size: 1em;
  line-height: normal;

  transition: color 0.3s, border-bottom 0.3s;

  &:hover {
    color: ${(props) => props.theme.colors.activeBlue};
  }
`;

const TabContent = styled.div`
  padding: 0px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.primaryWhite};
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.primaryWhite};
  }
`;

export {
  TabsContainer,
  TabsHeader,
  TabHeaderWrapper,
  Tab,
  TabContent,
  IconHeader,
  RightSide,  
}

